export default __webpack_public_path__ + "static/media/right-arrow.e81456fb.svg";